
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/escape-the-matrix",
      function () {
        return require("private-next-pages/escape-the-matrix/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/escape-the-matrix"])
      });
    }
  